import type { Matchday, Team, Translated } from '@uefadigital/panenka';

import type { VideoPlaylistFilters } from './types';

import type { EditorialContent } from '@cobalt/utilities';
import type { StateCreator } from '@shared-types/zustand.types';

type VideosSlice = {
  selectedVideo: EditorialContent;
  setSelected: (payload: EditorialContent) => void;
};

export const videosSlice: StateCreator<VideosSlice> = (set, get) => ({
  items: [],
  selectedVideo: null,
  setSelected: (payload: EditorialContent) => {
    if (payload?.id === get().selectedVideo?.id) {
      return;
    }
    set(() => ({ selectedVideo: payload }), false, 'setSelected');
  },
});

type FiltersSlice = {
  filters: VideoPlaylistFilters;
  setTeam: (payload: Translated<Team>) => void;
  setMatchday: (payload: Translated<Matchday>) => void;
  clearFilters: () => void;
};

export const filtersSlice: StateCreator<FiltersSlice> = (set) => ({
  filters: { matchday: null, team: null },
  setTeam: (payload: Translated<Team>) =>
    set(
      (state) => ({
        filters: { ...state.filters, team: payload },
      }),
      false,
      'setTeam',
    ),
  setMatchday: (payload: Translated<Matchday>) =>
    set(
      (state) => ({
        filters: { ...state.filters, matchday: payload },
      }),
      false,
      'setMatchday',
    ),
  clearFilters: () => set({ filters: { team: null, matchday: null } }, false, 'clearFilters'),
});

export type VideoPlaylistState = VideosSlice & FiltersSlice;
